import { useCalendarPickerStyles_unstable } from '../CalendarPicker/useCalendarPickerStyles.styles';
/**
 *  @internal
 *
 * Apply styling to the CalendarMonth slots based on the state
 */ export const useCalendarMonthStyles_unstable = (props)=>{
    'use no memo';
    return useCalendarPickerStyles_unstable(props);
};
